import { Button, Checkbox, Popup } from '@repo/design-system-kit';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { usePortalContainer } from '@repo/shared-kit/contexts/portal-container';

export function ConsentPopup({
  isOpen,
  onContinue,
  onCancel,
}: {
  isOpen: boolean;
  onContinue: () => void;
  onCancel: () => void;
}): React.JSX.Element {
  const intl = useIntl();
  const [isChecked, setIsChecked] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const portalContainer = usePortalContainer();
  const idnowTermsHref = intl.formatMessage({ id: 'links.idnowTerms' });
  const idnowPrivacyHref = intl.formatMessage({ id: 'links.idnowPrivacy' });

  return (
    <Popup.Root isOpen={isOpen} portalContainer={portalContainer}>
      <Popup.CloseButton
        data-test-close
        onPress={() => {
          setIsInvalid(false);
          onCancel();
        }}
      />
      <Popup.Header>
        <Popup.Title>
          <FormattedMessage
            defaultMessage="Agree to Terms and Conditions"
            id="qonto-idnow.computer.intro.idnow-terms-privacy-policy.title"
          />
        </Popup.Title>
      </Popup.Header>

      <Popup.Body>
        <div className="body-standard mb-16">
          <FormattedMessage
            id="qonto-idnow.computer.intro.idnow-terms-privacy-policy.subtitle"
            values={{
              idnowTermsLink: (chunks: React.ReactNode) => (
                <a
                  className="body-standard-link"
                  href={idnowTermsHref}
                  rel="noopener"
                  target="_blank"
                >
                  {chunks}
                </a>
              ),
              idnowPrivacyLink: (chunks: React.ReactNode) => (
                <a
                  className="body-standard-link"
                  href={idnowPrivacyHref}
                  rel="noopener"
                  target="_blank"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </div>

        <Checkbox
          aria-label={intl.formatMessage({
            id: 'qonto-idnow.computer.intro.idnow-terms-privacy-policy.title',
            defaultMessage: 'Agree to Terms and Conditions',
          })}
          data-test-terms
          errorMessage={intl.formatMessage({
            id: 'qonto-idnow.computer.intro.idnow-terms-privacy-policy.error',
            defaultMessage:
              'Confirm you agree to the IDnow Terms of Service and Privacy Policy and consent to the entire process being recorded.',
          })}
          isInvalid={isInvalid}
          isSelected={isChecked}
          onChange={value => {
            setIsChecked(value);
            setIsInvalid(state => state && !value);
          }}
        >
          <FormattedMessage
            defaultMessage="I agree to the IDnow Terms of Service and IDnow Privacy Policy."
            id="qonto-idnow.computer.intro.idnow-terms-privacy-policy.checkbox"
          />
        </Checkbox>
      </Popup.Body>

      <Popup.Footer>
        <Button
          data-test-continue
          onPress={() => {
            if (!isChecked) {
              setIsInvalid(true);
              return;
            }
            onContinue();
          }}
        >
          <FormattedMessage
            defaultMessage="Start video call"
            id="qonto-idnow.computer.intro.idnow-terms-privacy-policy.cta"
          />
        </Button>
      </Popup.Footer>
    </Popup.Root>
  );
}
